import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  spacing = tokens.spacing;
export var infoBox = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";");
export var header = {
  name: "95g4uk",
  styles: "display:flex;flex-direction:row;justify-content:space-between;align-items:center;"
};
export var headerDetail = {
  name: "149sczi",
  styles: "display:flex;flex-direction:row;align-items:center;gap:16px;"
};
export var logo = /*#__PURE__*/css("display:flex;align-items:center;justify-content:center;min-width:103px;max-width:103px;height:52px;padding:", spacing.xs, ";border:1px solid ", colors.neutral.trim.default, ";border-radius:3px;text-align:center;");
export var logoImg = {
  name: "ekruk9",
  styles: "max-height:36px;max-width:86px;"
};
export var entityType = /*#__PURE__*/css(designTokenFonts.bodyBold);
export var description = {
  name: "1yuhvjn",
  styles: "margin-top:16px;"
};
export var link = /*#__PURE__*/css(designTokenFonts.caption, " display:flex;gap:5px;margin-top:8px;padding-left:0;padding-right:0;color:", colors.interactive.base.default, ";&:hover,&:focus,&:active{color:", colors.interactive.base.default, ";}");